import actionTypes from '../../constants/action-types';

const copyCustomColorsCSSRuleForBlocks = (blocksIdsReferenceMap = null) => ({
  type: actionTypes.COPY_CUSTOM_COLORS_CSS_RULES_FOR_BLOCKS,
  payload: {
    blocksIdsReferenceMap,
  },
});

export default copyCustomColorsCSSRuleForBlocks;
